import { createSlice } from "@reduxjs/toolkit";

const reportsSlice = createSlice({
  name: "generic",
  initialState: {
    loading: false,
    error: null,
    data: null,
  },
  reducers: {
    apiRequest: (state) => {
      console.log("called api request")
      state.loading = true;
      state.error = null;
    },
    apiSuccess: (state, action) => {
      state.loading = false;
      state.data = action.payload;
    },
    apiFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
  },
});

export const { apiRequest, apiSuccess, apiFailure } = reportsSlice.actions;
export default reportsSlice.reducer;
